/* eslint semi: 1 */
export default {
  name: 'player-setup-display-orientation',
  components: {},
  mixins: [],
  props: {
    isMultipleDisplay: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: 'horizontal'
    }
  },
  data () {
    return {
      model: {
        orientation: this.orientation
      }
    };
  },
  watch: {
    orientation (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.orientation = newVal;
      }
    }
  }
};
